import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { AppSettings, defaults } from '../app.config';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { environment } from '../../environments/environment';

export const endpoint = environment.apiUrl + '/';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  constructor(private http: HttpClient,public router:Router){
  }
  get notify(): Observable<Record<string, any>> {
    return this.notify$.asObservable();
  }


  private extractData(res:any) {
    const  body = res;
    return body || { };
  }
  downloadFile(url: string, filename: string): void {
    this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
      saveAs(blob, filename);
    }, error => {
      console.error('Download error:', error);
    });
  }

  login(data:any):Observable<any>{
    return this.http.post(endpoint + 'users/login/',data).pipe(
      map(this.extractData));
  }

  
  
  getProfile():Observable<any>{
    return this.http.get(endpoint + 'user_details/',).pipe(
      map(this.extractData));
  }

  addOwner(data:any):Observable<any>{
    return this.http.post(endpoint + 'house_owners/',data).pipe(
      map(this.extractData));
  }
  getOwners(data:any):Observable<any>{
    return this.http.get(endpoint + 'house_owners/'+data).pipe(
      map(this.extractData));
  }

  getTripReport():Observable<any>{
    return this.http.get(endpoint + 'trips_report/',).pipe(
      map(this.extractData));
  }

  getVehicleReport():Observable<any>{
    return this.http.get(endpoint + 'vehicle_summary/',).pipe(
      map(this.extractData));
  }

  getTripSummaryReport():Observable<any>{
    return this.http.get(endpoint + 'trips_report_summary/',).pipe(
      map(this.extractData));
  }

  

  addEmployee(data:any):Observable<any>{
    return this.http.post(endpoint + 'add_employee/',data).pipe(
      map(this.extractData));
  }

 
  

  electricityMeters(data:any):Observable<any>{
    return this.http.get(endpoint + 'electricity_meters/'+data).pipe(
      map(this.extractData));
  }
  switchMeters(data:any):Observable<any>{
    return this.http.post(endpoint + 'switch_meter/',data).pipe(
      map(this.extractData));
  }


  getPayments(data:any):Observable<any>{
    return this.http.get(endpoint + 'payments/'+data).pipe(
      map(this.extractData));
  }

  

  createInvoice(data:any):Observable<any>{
    return this.http.post(endpoint + 'invoices/',data).pipe(
      map(this.extractData));
  }


  addPolicy(data:any):Observable<any>{
    return this.http.post(endpoint + 'leave_policy/',data).pipe(
      map(this.extractData));
  }


  getMonthlyTrips():Observable<any>{
    return this.http.get(endpoint + 'trips_monthly_summary/').pipe(
      map(this.extractData));
  }

  getTripsDocumennts(id:any):Observable<any>{
    return this.http.get(endpoint + 'trip_documents/'+id).pipe(
      map(this.extractData));
  }


  getTripsCounts():Observable<any>{
    return this.http.get(endpoint + 'trips_count_summary/').pipe(
      map(this.extractData));
  }

  getPolicy():Observable<any>{
    return this.http.get(endpoint + 'leave_policy/').pipe(
      map(this.extractData));
  }

  
  addCategory(data:any):Observable<any>{
    return this.http.post(endpoint + 'expense/',data).pipe(
      map(this.extractData));
  }

  getCategory():Observable<any>{
    return this.http.get(endpoint + 'expense/').pipe(
      map(this.extractData));
  }


  getTarrifs():Observable<any>{
    return this.http.get(endpoint + 'electricity_tariffs/').pipe(
      map(this.extractData));
  }
  addTarrifs(data:any):Observable<any>{
    return this.http.post(endpoint + 'electricity_tariffs/',data).pipe(
      map(this.extractData));
  }

  getPeriods(data:any):Observable<any>{
    return this.http.get(endpoint + 'periods/'+data).pipe(
      map(this.extractData));
  }
  addPeriod(data:any){
    return this.http.post(endpoint + 'periods/',data).pipe(
      map(this.extractData));
  }
  deletePeriod(id:any){
    return this.http.delete(endpoint + 'periods/'+id+'/').pipe(
      map(this.extractData));
  }


  getProductsOptions(data:any):Observable<any>{
    return this.http.get(endpoint + 'product_options/'+data).pipe(
      map(this.extractData));
  }



  addProductsOptions(data:any):Observable<any>{
    return this.http.post(endpoint + 'product_options/',data).pipe(
      map(this.extractData));
  }

  getProductsCategory(data:any){
    return this.http.get(endpoint + 'product_categories/'+data).pipe(
      map(this.extractData));
  }

  updateProductsCategory(data:any){
    return this.http.put(endpoint + 'product_categories/'+data.id+'/',data).pipe(
      map(this.extractData));
  }




  addProductsCategory(data:any){
    return this.http.post(endpoint + 'product_categories/',data).pipe(
      map(this.extractData));
  }
  
  deleteProductsCateogory(id:any):Observable<any>{
    return this.http.delete(endpoint + 'product_categories/'+id+'/').pipe(
      map(this.extractData));
  }

  updateProductsOptions(data:any):Observable<any>{
    return this.http.put(endpoint + 'product_options/'+data.id+'/',data).pipe(
      map(this.extractData));
  }




  
  addInsurance(data:any):Observable<any>{
    return this.http.post(endpoint + 'insurances/',data).pipe(
      map(this.extractData));
  }

  deleteProductsOptions(id:any):Observable<any>{
    return this.http.delete(endpoint + 'product_options/'+id+'/').pipe(
      map(this.extractData));
  }

  addProductOptions(data:''):Observable<any>{
    return this.http.post(endpoint + 'product_options/',data).pipe(
      map(this.extractData));
  }



  serviceTypeCategory(data:any):Observable<any>{
    return this.http.post(endpoint + 'service_types/',data).pipe(
      map(this.extractData));
  }

  getServiceTypes(data:any):Observable<any>{
    return this.http.get(endpoint + 'service_types/'+data).pipe(
      map(this.extractData));
  }




  
  areas(data:any):Observable<any>{
    return this.http.post(endpoint + 'areas/',data).pipe(
      map(this.extractData));
  }

  
  
  getAreas():Observable<any>{
    return this.http.get(endpoint + 'areas/').pipe(
      map(this.extractData));
  }

  addAllowance(data:any):Observable<any>{
    return this.http.post(endpoint + 'allowances/',data).pipe(
      map(this.extractData));
  }

  getAllowances():Observable<any>{
    return this.http.get(endpoint + 'allowances/').pipe(
      map(this.extractData));
  }
  addDeduction(data:any):Observable<any>{
    return this.http.post(endpoint + 'deductions/',data).pipe(
      map(this.extractData));
  
  }


  addDocument(data:any):Observable<any>{
    return this.http.post(endpoint + 'documents/',data).pipe(
      map(this.extractData));
  
  }

  addProductCategory(data:any):Observable<any>{
    return this.http.post(endpoint + 'product_category/',data).pipe(
      map(this.extractData));
  
  }

  deleteProductCategory(id:any):Observable<any>{
    return this.http.delete(endpoint + 'product_category/'+id+'/').pipe(
      map(this.extractData));
  
  }

  getPropertyCategorys(text:any):Observable<any>{
    return this.http.get(endpoint + 'property_categories/'+text).pipe(
      map(this.extractData));
  
  }

  addPropertyCategory(text:any):Observable<any>{
    return this.http.post(endpoint + 'property_categories/',text).pipe(
      map(this.extractData));
  
  }

  
  addPropertyTypes(data:any):Observable<any>{
    return this.http.post(endpoint + 'property_types/',data).pipe(
      map(this.extractData));
  
  }
  getPropertyTypes(data:any):Observable<any>{
    return this.http.get(endpoint + 'property_types/'+data).pipe(
      map(this.extractData));
  
  }
  

  getAccounts(text:any):Observable<any>{
    return this.http.get(endpoint + 'accounts/'+text).pipe(
      map(this.extractData));
  }

  
  addAccounts(text:any):Observable<any>{
    return this.http.post(endpoint + 'accounts/',text).pipe(
      map(this.extractData));
  }

  addUnits(text:any):Observable<any>{
    return this.http.post(endpoint + 'units/',text).pipe(
      map(this.extractData));
  }
  getUnits(text:any):Observable<any>{
    return this.http.get(endpoint + 'units/'+text).pipe(
      map(this.extractData));
  }
  getUnitDetail(text:any):Observable<any>{
    return this.http.get(endpoint + 'unit_details/'+text).pipe(
      map(this.extractData));
  }
  getBrands(text:any):Observable<any>{
    return this.http.get(endpoint + 'brands/'+text).pipe(
      map(this.extractData));
  }

  getDocument(data:any):Observable<any>{
    return this.http.post(endpoint + 'documents/',data).pipe(
      map(this.extractData));
  
  }


  getDocuments():Observable<any>{
    return this.http.get(endpoint + 'documents/').pipe(
      map(this.extractData));
  
  }

  getDeductions():Observable<any>{
    return this.http.get(endpoint + 'deductions/').pipe(
      map(this.extractData));
  }


  createExpense(data:any):Observable<any>{
    return this.http.post(endpoint + 'expenses/',data).pipe(
      map(this.extractData));
  }


  addBranch(data:any):Observable<any>{
    return this.http.post(endpoint + 'branches/',data).pipe(
      map(this.extractData));
  }


  addProperty(data:any):Observable<any>{
    return this.http.post(endpoint + 'properties/',data).pipe(
      map(this.extractData));
  }

  getProperty(data:any):Observable<any>{
    return this.http.get(endpoint + 'properties/'+data).pipe(
      map(this.extractData));
  }

  addBlock(data:any):Observable<any>{
    return this.http.post(endpoint + 'blocks/',data).pipe(
      map(this.extractData));
  }


  getBlocks(data:any):Observable<any>{
    return this.http.get(endpoint + 'blocks/'+data).pipe(
      map(this.extractData));
  }

  
  updateBranch(data:any):Observable<any>{
    return this.http.put(endpoint + 'branches/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  addDepartment(data:any):Observable<any>{
    return this.http.post(endpoint + 'department/',data).pipe(
      map(this.extractData));
  }

  addRole(data:any):Observable<any>{
    return this.http.post(endpoint + 'role/',data).pipe(
      map(this.extractData));
  }


  getUsers(text:any):Observable<any>{
    return this.http.get(endpoint + 'users/users/'+text).pipe(
      map(this.extractData));
  }

  
  getUserDetails():Observable<any>{
    return this.http.get(endpoint + 'users/user_info/').pipe(
      map(this.extractData));
  }


  

  profileUpload(data:any):Observable<any>{
    return this.http.post(endpoint + 'profile_upload/',data).pipe(
      map(this.extractData));
  }




  getUser(id:any):Observable<any>{
    return this.http.get(endpoint + 'users/'+id+'/').pipe(
      map(this.extractData));
  }

  addUser(data:any):Observable<any>{
    return this.http.post(endpoint + 'users/',data).pipe(
      map(this.extractData));
  }

  createFuelOrder(data:any):Observable<any>{
    return this.http.post(endpoint + 'fuel_orders/',data).pipe(
      map(this.extractData));
  }


  completeTrip(data:any):Observable<any>{
    return this.http.post(endpoint + 'complete_trip/',data).pipe(
      map(this.extractData));
  }
  
  // Legacy purchase order methods - replaced by procurement system
  createLegacyPurchaseOrder(data:any):Observable<any>{
    return this.http.post(endpoint + 'purchase_orders/',data).pipe(
      map(this.extractData));
  }
  getLegacyPurchaseOrder(data:any):Observable<any>{
    return this.http.get(endpoint + 'purchase_orders/'+data).pipe(
      map(this.extractData));
  }
  getFuelOrders(text:any):Observable<any>{
    return this.http.get(endpoint + 'fuel_orders/'+text).pipe(
      map(this.extractData));
  }

  getFuelOrdersImages(text:any):Observable<any>{
    return this.http.get(endpoint + 'fuel_order_images/'+text).pipe(
      map(this.extractData));
  }

  updateUser(id:any,data:any):Observable<any>{
    return this.http.put(endpoint + 'users/'+id+'/',data).pipe(
      map(this.extractData));
  }
  
  changePassword(data:any):Observable<any>{
    return this.http.post(endpoint + 'change_password/',data).pipe(
      map(this.extractData));
  }


  

  updateRole(data:any):Observable<any>{
    return this.http.put(endpoint + 'role/'+data.id+'/',data).pipe(
      map(this.extractData));
  }
  
  getRoles():Observable<any>{
    return this.http.get(endpoint + 'role/').pipe(
      map(this.extractData));
  }

  getPermissions():Observable<any>{
    return this.http.get(endpoint + 'permissions/').pipe(
      map(this.extractData));
  }

  addPermission(data:any):Observable<any>{
    return this.http.post(endpoint + 'permissions/',data).pipe(
      map(this.extractData));
  }

  updatePermission(id:any,data:any):Observable<any>{
    return this.http.put(endpoint + 'permissions/'+id+'/',data).pipe(
      map(this.extractData));
  }

  deletePermission(id:any):Observable<any>{
    return this.http.delete(endpoint + 'permissions/'+id+'/').pipe(
      map(this.extractData));
  }

  getPermission(id:any):Observable<any>{
    return this.http.get(endpoint + 'permissions/'+id+'/').pipe(
      map(this.extractData));
  }

  getGroups():Observable<any>{
    return this.http.get(endpoint + 'groups/').pipe(
      map(this.extractData));
  }

  addGroup(data:any):Observable<any>{
    return this.http.post(endpoint + 'groups/',data).pipe(
      map(this.extractData));
  }

  updateGroup(id:any,data:any):Observable<any>{
    return this.http.put(endpoint + 'groups/'+id+'/',data).pipe(
      map(this.extractData));
  }

  deleteGroup(id:any):Observable<any>{
    return this.http.delete(endpoint + 'groups/'+id+'/').pipe(
      map(this.extractData));
  }

  getGroup(id:any):Observable<any>{
    return this.http.get(endpoint + 'groups/'+id+'/').pipe(
      map(this.extractData));
  }

  getPages():Observable<any>{
    return this.http.get(endpoint + 'pages/').pipe(
      map(this.extractData));
  }

  addPage(data:any):Observable<any>{
    return this.http.post(endpoint + 'pages/',data).pipe(
      map(this.extractData));
  }

  updatePage(id:any,data:any):Observable<any>{
    return this.http.put(endpoint + 'pages/'+id+'/',data).pipe(
      map(this.extractData));
  }

  deletePage(id:any):Observable<any>{
    return this.http.delete(endpoint + 'pages/'+id+'/').pipe(
      map(this.extractData));
  }

  getPage(id:any):Observable<any>{
    return this.http.get(endpoint + 'pages/'+id+'/').pipe(
      map(this.extractData));
  }


  deleteRole(id:any){
    return this.http.delete(endpoint + 'role/'+id+'/').pipe(
      map(this.extractData));
  }


    
  getProperties():Observable<any>{
    return this.http.get(endpoint + 'properties/').pipe(
      map(this.extractData));
  }


  addEmploymentType(data:any):Observable<any>{
    return this.http.post(endpoint + 'employment_type/',data).pipe(
      map(this.extractData));
  }

  getEmploymentTypes():Observable<any>{
    return this.http.get(endpoint + 'employment_type/').pipe(
      map(this.extractData));
  }
  updateEmploymentType(data:any):Observable<any>{
    return this.http.put(endpoint + 'employment_type/'+data.id+'/',data).pipe(
      map(this.extractData));
  }
  getBranchs():Observable<any>{
    return this.http.get(endpoint + 'branches/').pipe(
      map(this.extractData));
  }
  getBranch(id:any):Observable<any>{
    return this.http.get(endpoint + 'branches/'+id+'/').pipe(
      map(this.extractData));
  }
  
  getCompanies(text:''):Observable<any>{
    return this.http.get(endpoint + 'companies/').pipe(
      map(this.extractData));
  }

  getCompany(id:any):Observable<any>{
    return this.http.get(endpoint + 'companies/'+id+'/').pipe(
      map(this.extractData));
  }

  addCompany(data:any):Observable<any>{
    return this.http.post(endpoint + 'companies/',data).pipe(
      map(this.extractData));
  }

  updateCompany(id:any,data:any):Observable<any>{
    return this.http.put(endpoint + 'companies/'+id+'/',data).pipe(
      map(this.extractData));
  }

  deleteCompany(id:any):Observable<any>{
    return this.http.delete(endpoint + 'companies/'+id+'/').pipe(
      map(this.extractData));
  }

  getCustomers(text:any):Observable<any>{
    return this.http.get(endpoint + 'quotes/customers/'+text).pipe(
      map(this.extractData));
  }

  getInsurances(text:any):Observable<any>{
    return this.http.get(endpoint + 'insurances/'+text).pipe(
      map(this.extractData));
  }

  addInsuranceProduct(data:any){
    return this.http.post(endpoint + 'insurance_products/',data).pipe(
      map(this.extractData));
  }

  addTenants(text:any):Observable<any>{
    return this.http.post(endpoint + 'tenants/',text).pipe(
      map(this.extractData));
  }

  
  getTenants(text:any):Observable<any>{
    return this.http.get(endpoint + 'tenants/'+text).pipe(
      map(this.extractData));
  }

  deleteCustomers(id:any):Observable<any>{
    return this.http.delete(endpoint + 'customers/'+id+'/').pipe(
      map(this.extractData));
  }

  addCustomer(data:any):Observable<any>{
    return this.http.post(endpoint + 'customers/',data).pipe(
      map(this.extractData));
  }

  // Customer methods for quotes app
  getCustomer(id: string): Observable<any> {
    return this.http.get(endpoint + 'quotes/customers/' + id + '/').pipe(
      map(this.extractData));
  }

  createCustomer(data: any): Observable<any> {
    return this.http.post(endpoint + 'quotes/customers/', data).pipe(
      map(this.extractData));
  }

  updateCustomer(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'quotes/customers/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteCustomer(id: string): Observable<any> {
    return this.http.delete(endpoint + 'quotes/customers/' + id + '/').pipe(
      map(this.extractData));
  }
  

  // Suppliers - Updated to match backend procurement system
  addSupplier(data:any):Observable<any>{
    return this.http.post(endpoint + 'procurement/suppliers/',data).pipe(
      map(this.extractData));
  }

  addSupplierWithPricing(data:any):Observable<any>{
    // For backward compatibility - create supplier then add contacts
    return this.addSupplier(data);
  }

  updateSupplier(data:any):Observable<any>{
    return this.http.put(endpoint + 'procurement/suppliers/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  getSupplier(id:any):Observable<any>{
    return this.http.get(endpoint + 'procurement/suppliers/'+id+'/').pipe(
      map(this.extractData));
  }

  getSuppliers(params?: any):Observable<any>{
    let url = endpoint + 'procurement/suppliers/';
    if (params) {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          queryParams.append(key, params[key]);
        }
      });
      url += '?' + queryParams.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  deleteSupplier(id:any):Observable<any>{
    return this.http.delete(endpoint + 'procurement/suppliers/'+id+'/').pipe(
      map(this.extractData));
  }

  // Supplier Actions
  activateSupplier(id: string): Observable<any> {
    return this.http.post(endpoint + 'procurement/suppliers/' + id + '/activate/', {}).pipe(
      map(this.extractData));
  }

  deactivateSupplier(id: string): Observable<any> {
    return this.http.post(endpoint + 'procurement/suppliers/' + id + '/deactivate/', {}).pipe(
      map(this.extractData));
  }

  // Supplier Contacts
  getSupplierContacts(supplierId?: string): Observable<any> {
    const url = supplierId 
      ? endpoint + 'procurement/supplier-contacts/?supplier=' + supplierId
      : endpoint + 'procurement/supplier-contacts/';
    return this.http.get(url).pipe(map(this.extractData));
  }

  addSupplierContact(data: any): Observable<any> {
    return this.http.post(endpoint + 'procurement/supplier-contacts/', data).pipe(
      map(this.extractData));
  }

  updateSupplierContact(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'procurement/supplier-contacts/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteSupplierContact(id: string): Observable<any> {
    return this.http.delete(endpoint + 'procurement/supplier-contacts/' + id + '/').pipe(
      map(this.extractData));
  }

  // Purchase Orders
  getPurchaseOrders(params?: any): Observable<any> {
    let url = endpoint + 'procurement/purchase-orders/';
    if (params) {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          queryParams.append(key, params[key]);
        }
      });
      url += '?' + queryParams.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getPurchaseOrder(id: string): Observable<any> {
    return this.http.get(endpoint + 'procurement/purchase-orders/' + id + '/').pipe(
      map(this.extractData));
  }

  createPurchaseOrder(data: any): Observable<any> {
    return this.http.post(endpoint + 'procurement/purchase-orders/', data).pipe(
      map(this.extractData));
  }

  updatePurchaseOrder(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'procurement/purchase-orders/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deletePurchaseOrder(id: string): Observable<any> {
    return this.http.delete(endpoint + 'procurement/purchase-orders/' + id + '/').pipe(
      map(this.extractData));
  }

  sendPurchaseOrderToSupplier(id: string): Observable<any> {
    return this.http.post(endpoint + 'procurement/purchase-orders/' + id + '/send_to_supplier/', {}).pipe(
      map(this.extractData));
  }

  confirmPurchaseOrder(id: string): Observable<any> {
    return this.http.post(endpoint + 'procurement/purchase-orders/' + id + '/confirm/', {}).pipe(
      map(this.extractData));
  }

  cancelPurchaseOrder(id: string): Observable<any> {
    return this.http.post(endpoint + 'procurement/purchase-orders/' + id + '/cancel/', {}).pipe(
      map(this.extractData));
  }

  // Purchase Order Items
  getPurchaseOrderItems(poId: string): Observable<any> {
    return this.http.get(endpoint + 'procurement/purchase-orders/' + poId + '/items/').pipe(
      map(this.extractData));
  }

  createPurchaseOrderItem(data: any): Observable<any> {
    return this.http.post(endpoint + 'procurement/purchase-order-items/', data).pipe(
      map(this.extractData));
  }

  updatePurchaseOrderItem(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'procurement/purchase-order-items/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deletePurchaseOrderItem(id: string): Observable<any> {
    return this.http.delete(endpoint + 'procurement/purchase-order-items/' + id + '/').pipe(
      map(this.extractData));
  }

  // Bills (Procurement)
  getProcurementBills(params?: any): Observable<any> {
    let url = endpoint + 'procurement/bills/';
    if (params) {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          queryParams.append(key, params[key]);
        }
      });
      url += '?' + queryParams.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getProcurementBill(id: string): Observable<any> {
    return this.http.get(endpoint + 'procurement/bills/' + id + '/').pipe(
      map(this.extractData));
  }

  createProcurementBill(data: any): Observable<any> {
    return this.http.post(endpoint + 'procurement/bills/', data).pipe(
      map(this.extractData));
  }

  updateProcurementBill(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'procurement/bills/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteProcurementBill(id: string): Observable<any> {
    return this.http.delete(endpoint + 'procurement/bills/' + id + '/').pipe(
      map(this.extractData));
  }

  approveBill(id: string): Observable<any> {
    return this.http.post(endpoint + 'procurement/bills/' + id + '/approve/', {}).pipe(
      map(this.extractData));
  }

  disputeBill(id: string, data: any): Observable<any> {
    return this.http.post(endpoint + 'procurement/bills/' + id + '/dispute/', data).pipe(
      map(this.extractData));
  }

  getOverdueBills(): Observable<any> {
    return this.http.get(endpoint + 'procurement/bills/overdue/').pipe(
      map(this.extractData));
  }

  // Supplier Payments
  getSupplierPayments(params?: any): Observable<any> {
    let url = endpoint + 'procurement/supplier-payments/';
    if (params) {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          queryParams.append(key, params[key]);
        }
      });
      url += '?' + queryParams.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createSupplierPayment(data: any): Observable<any> {
    return this.http.post(endpoint + 'procurement/supplier-payments/', data).pipe(
      map(this.extractData));
  }

  approveSupplierPayment(id: string): Observable<any> {
    return this.http.post(endpoint + 'procurement/supplier-payments/' + id + '/approve/', {}).pipe(
      map(this.extractData));
  }

  completeSupplierPayment(id: string): Observable<any> {
    return this.http.post(endpoint + 'procurement/supplier-payments/' + id + '/complete/', {}).pipe(
      map(this.extractData));
  }

  getSupplierPricing(supplierId:any, categoryId?:any):Observable<any>{
    const url = categoryId 
      ? endpoint + 'suppliers/service_providers/'+supplierId+'/pricing/?category='+categoryId
      : endpoint + 'suppliers/service_providers/'+supplierId+'/pricing/';
    return this.http.get(url).pipe(
      map(this.extractData));
  }

  getServiceCategories():Observable<any>{
    return this.http.get(endpoint + 'services/service_categories/').pipe(
      map(this.extractData));
  }

  // Payment Methods
  getPaymentMethods():Observable<any>{
    return this.http.get(endpoint + 'accounting/payment_methods/').pipe(
      map(this.extractData));
  }

  // Payment Terms
  getPaymentTerms():Observable<any>{
    return this.http.get(endpoint + 'accounting/payment-terms/').pipe(
      map(this.extractData));
  }

  addPaymentMethod(data:any):Observable<any>{
    return this.http.post(endpoint + 'payments/payment_methods/',data).pipe(
      map(this.extractData));
  }

  updatePaymentMethod(data:any):Observable<any>{
    return this.http.put(endpoint + 'payments/payment_methods/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  deletePaymentMethod(id:any):Observable<any>{
    return this.http.delete(endpoint + 'payments/payment_methods/'+id+'/').pipe(
      map(this.extractData));
  }

  // Transaction Types
  getTransactionTypes():Observable<any>{
    return this.http.get(endpoint + 'payments/transaction_types/').pipe(
      map(this.extractData));
  }

  addTransactionType(data:any):Observable<any>{
    return this.http.post(endpoint + 'payments/transaction_types/',data).pipe(
      map(this.extractData));
  }

  updateTransactionType(data:any):Observable<any>{
    return this.http.put(endpoint + 'payments/transaction_types/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  deleteTransactionType(id:any):Observable<any>{
    return this.http.delete(endpoint + 'payments/transaction_types/'+id+'/').pipe(
      map(this.extractData));
  }

  createTransaction(data:any):Observable<any>{
    return this.http.post(endpoint + 'payments/transactions/',data).pipe(
      map(this.extractData));
  }

  getTransactions(text:any):Observable<any>{
    return this.http.get(endpoint + 'payments/transactions/'+text).pipe(
      map(this.extractData));
  }

  updateTransaction(data:any):Observable<any>{
    return this.http.put(endpoint + 'payments/transactions/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  deleteTransaction(id:any):Observable<any>{
    return this.http.delete(endpoint + 'payments/transactions/'+id+'/').pipe(
      map(this.extractData));
  }

  // Service Categories API
  addServiceCategory(data:any):Observable<any>{
    return this.http.post(endpoint + 'services/categories/',data).pipe(
      map(this.extractData));
  }

  updateServiceCategory(data:any):Observable<any>{
    return this.http.put(endpoint + 'services/categories/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  deleteServiceCategory(id:any):Observable<any>{
    return this.http.delete(endpoint + 'services/categories/'+id+'/').pipe(
      map(this.extractData));
  }

  // Services API
  addService(data:any):Observable<any>{
    return this.http.post(endpoint + 'services/',data).pipe(
      map(this.extractData));
  }

  updateService(data:any):Observable<any>{
    return this.http.put(endpoint + 'services/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  deleteService(id:any):Observable<any>{
    return this.http.delete(endpoint + 'services/'+id+'/').pipe(
      map(this.extractData));
  }

  getServices(text:any):Observable<any>{
    return this.http.get(endpoint + 'services/'+text).pipe(
      map(this.extractData));
  }

  // Service Requests API
  addServiceRequest(data:any):Observable<any>{
    return this.http.post(endpoint + 'service_requests/',data).pipe(
      map(this.extractData));
  }

  updateServiceRequest(data:any):Observable<any>{
    return this.http.put(endpoint + 'service_requests/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  deleteServiceRequest(id:any):Observable<any>{
    return this.http.delete(endpoint + 'service_requests/'+id+'/').pipe(
      map(this.extractData));
  }

  getServiceRequests(text:any):Observable<any>{
    return this.http.get(endpoint + 'services/service_requests/'+text).pipe(
      map(this.extractData));
  }

  // Reviews API
  addReview(data:any):Observable<any>{
    return this.http.post(endpoint + 'services/reviews/',data).pipe(
      map(this.extractData));
  }

  updateReview(data:any):Observable<any>{
    return this.http.put(endpoint + 'services/reviews/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  deleteReview(id:any):Observable<any>{
    return this.http.delete(endpoint + 'services/reviews/'+id+'/').pipe(
      map(this.extractData));
  }

  getReviews(text:any):Observable<any>{
    return this.http.get(endpoint + 'services/reviews/'+text).pipe(
      map(this.extractData));
  }

  

  addStation(data:any):Observable<any>{
    return this.http.post(endpoint + 'stations/',data).pipe(
      map(this.extractData));
  }
  

  getStations():Observable<any>{
    return this.http.get(endpoint + 'stations/').pipe(
      map(this.extractData));
  }
  getStation(id:any):Observable<any>{
    return this.http.get(endpoint + 'stations/'+id).pipe(
      map(this.extractData));
  }
  

  updateStation(data:any):Observable<any>{
    return this.http.put(endpoint + 'stations/'+data.id+'/',data).pipe(
      map(this.extractData));
  }
  
  deleteStation(id:any):Observable<any>{
    return this.http.delete(endpoint + 'stations/'+id+'/').pipe(
      map(this.extractData));
  }
  
  addStationRate(data:any):Observable<any>{
    return this.http.post(endpoint + 'station_rate/',data).pipe(
      map(this.extractData));
  }

  getStationRates(id:any):Observable<any>{
    return this.http.get(endpoint + 'station_rate/?station='+id).pipe(
      map(this.extractData));
  }
  addRoute(data:any):Observable<any>{
    return this.http.post(endpoint + 'routes/',data).pipe(
      map(this.extractData));
  }
  
  getRoutes():Observable<any>{
    return this.http.get(endpoint + 'routes/').pipe(
      map(this.extractData));
  }

  addTask(data:any):Observable<any>{
    return this.http.post(endpoint + 'tasks/',data).pipe(
      map(this.extractData));
  }

  getTasks(text:any):Observable<any>{
    return this.http.get(endpoint + 'tasks/'+text).pipe(
      map(this.extractData));
  }

  getIssues(text:any):Observable<any>{
    return this.http.get(endpoint + 'delay/'+text).pipe(
      map(this.extractData));
  }
  

  searchIssues(text:any):Observable<any>{
    return this.http.post(endpoint + 'delay/search/',text).pipe(
      map(this.extractData));
  }
  
  
  
  deleteIssues(text:any):Observable<any>{
    return this.http.delete(endpoint + 'delay/'+text+'/').pipe(
      map(this.extractData));
  }
  
  
  getTripDetail(id:any):Observable<any>{
    return this.http.get(endpoint + 'trip-detail/'+id+'/').pipe(
      map(this.extractData));
  }

  createTrip(data:any):Observable<any>{
    return this.http.post(endpoint + 'trips/',data).pipe(
      map(this.extractData));
  }

  
  updateTrip(data:any):Observable<any>{
    return this.http.put(endpoint + 'trips/'+data.id+'/',data).pipe(
      map(this.extractData));
  }
  getTrips(data:any):Observable<any>{
    return this.http.get(endpoint + 'trips/'+data).pipe(
      map(this.extractData));
  }

  searchTrips(data:any):Observable<any>{
    return this.http.post(endpoint + 'trips/search/',data).pipe(
      map(this.extractData));
  }

  getOrders():Observable<any>{
    return this.http.get(endpoint + 'orders/').pipe(
      map(this.extractData));
  }

  getTask(id:any):Observable<any>{
    return this.http.get(endpoint + 'tasks/'+id+'/').pipe(
      map(this.extractData));
  }
  deleteTask(id:any):Observable<any>{
    return this.http.delete(endpoint + 'tasks/'+id+'/').pipe(
      map(this.extractData));
  }

  deleteRoute(id:any):Observable<any>{
    return this.http.delete(endpoint + 'routes/'+id+'/').pipe(
      map(this.extractData));
  }
  
  addProduct(data:any):Observable<any>{
    return this.http.post(endpoint + 'products/',data).pipe(
      map(this.extractData));
  }


  updateProduct(data:any):Observable<any>{
    return this.http.put(endpoint + 'products/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  addVehicle(data:any):Observable<any>{
    return this.http.post(endpoint + 'vehicles/',data).pipe(
      map(this.extractData));
  }

  addTrailer(data:any):Observable<any>{
    return this.http.post(endpoint + 'trailers/',data).pipe(
      map(this.extractData));
  }
  getTrailer(data:any):Observable<any>{
    return this.http.get(endpoint + 'trailers/'+data).pipe(
      map(this.extractData));
  }

  updateTrailer(data:any):Observable<any>{
    return this.http.put(endpoint + 'trailers/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  

  

  getVehicle(id:any):Observable<any>{
    return this.http.get(endpoint + 'vehicles/'+id+'/').pipe(
      map(this.extractData));
  }



  
  updateVehicle(data:any):Observable<any>{
    return this.http.put(endpoint + 'vehicles/'+data.id+'/',data).pipe(
      map(this.extractData));
  }


  addFile(data:any):Observable<any>{
    return this.http.post(endpoint + 'files/',data).pipe(
      map(this.extractData));
  }
  getFiles(data:any):Observable<any>{
    return this.http.get(endpoint + 'files/'+data).pipe(
      map(this.extractData));
  }
  getVehicles(text:any):Observable<any>{
    return this.http.get(endpoint + 'vehicles/'+text).pipe(
      map(this.extractData));
  }


  getProducts(text:any):Observable<any>{
    return this.http.get(endpoint + 'products/'+text).pipe(
      map(this.extractData));
  }
  

  createJobcard(data:any):Observable<any>{
    return this.http.post(endpoint + 'jobcard/',data).pipe(
      map(this.extractData));
  }

  addJobCardItem(data:any){
    return this.http.post(endpoint + 'add_jobcard_item/',data).pipe(
      map(this.extractData));
  }

  
  jobcardApprovalRequest(data:any){
    return this.http.post(endpoint + 'request_jobcard_approval/',data).pipe(
      map(this.extractData));
  }

  
  editJobCardItem(data:any){
    return this.http.post(endpoint + 'update_jobcard_item/',data).pipe(
      map(this.extractData));
  }


  completeJobCard(data:any){
    return this.http.post(endpoint + 'complete_jobcard/',data).pipe(
      map(this.extractData));
  }

  deleteJobCardItem(data:any){
    return this.http.post(endpoint + 'delete_jobcard_item/',data).pipe(
      map(this.extractData));
  }
  
  cancelJobCardItem(data:any){
    return this.http.post(endpoint + 'cancel_jobcard/',data).pipe(
      map(this.extractData));
  }

  getJobcards(text:any):Observable<any>{
    return this.http.get(endpoint + 'jobcard/'+text).pipe(
      map(this.extractData));
  }

  searchJobcards(text:any):Observable<any>{
    return this.http.post(endpoint + 'jobcard/search/',text).pipe(
      map(this.extractData));
  }
  getJobcardItems(text:any):Observable<any>{
    return this.http.get(endpoint + 'jobcard_items/'+text).pipe(
      map(this.extractData));
  }

  getPurchaseItems(text:any){
    return this.http.get(endpoint + 'order_items/'+text).pipe(
      map(this.extractData));
  }
  addPurchaseItems(data:any){
    return this.http.post(endpoint + 'order_items/',data).pipe(
      map(this.extractData));
  }

  updatePurchaseItems(data:any){
    return this.http.put(endpoint + 'order_items/'+data.id+'/',data).pipe(
      map(this.extractData));
  }

  deletePurchaseItems(id:any){
    return this.http.delete(endpoint + 'order_items/'+id+'/').pipe(
      map(this.extractData));
  }


  receivePurchase(data:any){
    return this.http.post(endpoint + 'receive_order/',data).pipe(
      map(this.extractData));
  }

  

  leaveRequest(data:any):Observable<any>{
    return this.http.post(endpoint + 'leave-requests/',data).pipe(
      map(this.extractData));
  }
  

  

  getLeaveRequest():Observable<any>{
    return this.http.get(endpoint + 'leave-requests/').pipe(
      map(this.extractData));
  }
  
  getLeaveRequestByStatus(text:any):Observable<any>{
    return this.http.get(endpoint + 'leave-requests/?status='+text).pipe(
      map(this.extractData));
  }
  
  getDepartments():Observable<any>{
    return this.http.get(endpoint + 'department/').pipe(
      map(this.extractData));
  }

  // Tour Packages Methods
  getTourPackages(data?: any): Observable<any> {
    let url = endpoint + 'tours/packages/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getTourPackage(id: string): Observable<any> {
    return this.http.get(endpoint + 'tours/packages/' + id + '/').pipe(
      map(this.extractData));
  }

  createTourPackage(data: any): Observable<any> {
    return this.http.post(endpoint + 'tours/packages/', data).pipe(
      map(this.extractData));
  }

  updateTourPackage(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'tours/packages/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteTourPackage(id: string): Observable<any> {
    return this.http.delete(endpoint + 'tours/packages/' + id + '/').pipe(
      map(this.extractData));
  }

  // Tour Itineraries Methods
  getTourItineraries(data?: any): Observable<any> {
    let url = endpoint + 'tours/itineraries/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createTourItinerary(data: any): Observable<any> {
    return this.http.post(endpoint + 'tours/itineraries/', data).pipe(
      map(this.extractData));
  }

  updateTourItinerary(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'tours/itineraries/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteTourItinerary(id: string): Observable<any> {
    return this.http.delete(endpoint + 'tours/itineraries/' + id + '/').pipe(
      map(this.extractData));
  }

  // Tour Seasons Methods
  getTourSeasons(data?: any): Observable<any> {
    let url = endpoint + 'tours/seasons/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createTourSeason(data: any): Observable<any> {
    return this.http.post(endpoint + 'tours/seasons/', data).pipe(
      map(this.extractData));
  }

  updateTourSeason(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'tours/seasons/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteTourSeason(id: string): Observable<any> {
    return this.http.delete(endpoint + 'tours/seasons/' + id + '/').pipe(
      map(this.extractData));
  }

  getTourSeason(id: string): Observable<any> {
    return this.http.get(endpoint + 'tours/seasons/' + id + '/').pipe(
      map(this.extractData));
  }

  // Get seasons by package (if needed for filtering)
  getSeasonsByPackage(packageId: string): Observable<any> {
    return this.http.get(endpoint + 'tours/seasons/?tour_package=' + packageId).pipe(
      map(this.extractData));
  }

  // Get active seasons only
  getActiveSeasons(): Observable<any> {
    return this.http.get(endpoint + 'tours/seasons/?is_active=true').pipe(
      map(this.extractData));
  }

  // Destinations and Accommodations (from accommodations app)
  getDestinations(): Observable<any> {
    return this.http.get(endpoint + 'accommodations/destinations/').pipe(
      map(this.extractData));
  }

  getAccommodations(data?: any): Observable<any> {
    let url = endpoint + 'accommodations/accommodations/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  // Destination CRUD Methods
  createDestination(data: any): Observable<any> {
    return this.http.post(endpoint + 'accommodations/destinations/', data).pipe(
      map(this.extractData));
  }

  updateDestination(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'accommodations/destinations/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteDestination(id: string): Observable<any> {
    return this.http.delete(endpoint + 'accommodations/destinations/' + id + '/').pipe(
      map(this.extractData));
  }

  getDestination(id: string): Observable<any> {
    return this.http.get(endpoint + 'accommodations/destinations/' + id + '/').pipe(
      map(this.extractData));
  }

  // Accommodation CRUD Methods
  createAccommodation(data: any): Observable<any> {
    return this.http.post(endpoint + 'accommodations/accommodations/', data).pipe(
      map(this.extractData));
  }

  updateAccommodation(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'accommodations/accommodations/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteAccommodation(id: string): Observable<any> {
    return this.http.delete(endpoint + 'accommodations/accommodations/' + id + '/').pipe(
      map(this.extractData));
  }

  getAccommodation(id: string): Observable<any> {
    return this.http.get(endpoint + 'accommodations/accommodations/' + id + '/').pipe(
      map(this.extractData));
  }

  // Meal Plans Methods
  getMealPlans(data?: any): Observable<any> {
    let url = endpoint + 'accommodations/meal-plans/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createMealPlan(data: any): Observable<any> {
    return this.http.post(endpoint + 'accommodations/meal-plans/', data).pipe(
      map(this.extractData));
  }

  updateMealPlan(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'accommodations/meal-plans/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteMealPlan(id: string): Observable<any> {
    return this.http.delete(endpoint + 'accommodations/meal-plans/' + id + '/').pipe(
      map(this.extractData));
  }

  // Room Types Methods
  getRoomTypes(data?: any): Observable<any> {
    let url = endpoint + 'accommodations/room-types/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createRoomType(data: any): Observable<any> {
    return this.http.post(endpoint + 'accommodations/room-types/', data).pipe(
      map(this.extractData));
  }

  updateRoomType(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'accommodations/room-types/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteRoomType(id: string): Observable<any> {
    return this.http.delete(endpoint + 'accommodations/room-types/' + id + '/').pipe(
      map(this.extractData));
  }

  // Pricing Methods
  getAccommodationRates(data?: any): Observable<any> {
    let url = endpoint + 'pricing/accommodation-rates/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createAccommodationRate(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/accommodation-rates/', data).pipe(
      map(this.extractData));
  }

  updateAccommodationRate(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/accommodation-rates/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteAccommodationRate(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/accommodation-rates/' + id + '/').pipe(
      map(this.extractData));
  }

  // Meal Plan Rates Methods - Using accommodation-rates endpoint for meal rates
  getAccommodationMealRates(data?: any): Observable<any> {
    let url = endpoint + 'pricing/accommodation-rates/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createAccommodationMealRate(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/accommodation-rates/', data).pipe(
      map(this.extractData));
  }

  updateAccommodationMealRate(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/accommodation-rates/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteAccommodationMealRate(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/accommodation-rates/' + id + '/').pipe(
      map(this.extractData));
  }

  // Hotel Seasonal Multipliers Methods - Using hotel-multipliers endpoint
  getHotelSeasonalMultipliers(data?: any): Observable<any> {
    let url = endpoint + 'pricing/hotel-multipliers/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createHotelSeasonalMultiplier(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/hotel-multipliers/', data).pipe(
      map(this.extractData));
  }

  updateHotelSeasonalMultiplier(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/hotel-multipliers/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteHotelSeasonalMultiplier(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/hotel-multipliers/' + id + '/').pipe(
      map(this.extractData));
  }

  getTransportCosts(data?: any): Observable<any> {
    let url = endpoint + 'pricing/transport-costs/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createTransportCost(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/transport-costs/', data).pipe(
      map(this.extractData));
  }

  updateTransportCost(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/transport-costs/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteTransportCost(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/transport-costs/' + id + '/').pipe(
      map(this.extractData));
  }

  getMarkupRates(data?: any): Observable<any> {
    let url = endpoint + 'pricing/markup-rates/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createMarkupRate(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/markup-rates/', data).pipe(
      map(this.extractData));
  }

  updateMarkupRate(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/markup-rates/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteMarkupRate(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/markup-rates/' + id + '/').pipe(
      map(this.extractData));
  }

  getPackagePricing(data?: any): Observable<any> {
    let url = endpoint + 'pricing/package-pricing/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createPackagePricing(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/package-pricing/', data).pipe(
      map(this.extractData));
  }

  updatePackagePricing(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/package-pricing/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deletePackagePricing(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/package-pricing/' + id + '/').pipe(
      map(this.extractData));
  }

  // Meal Plan Rates Methods
  getMealPlanRates(data?: any): Observable<any> {
    let url = endpoint + 'pricing/meal-plan-rates/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createMealPlanRate(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/meal-plan-rates/', data).pipe(
      map(this.extractData));
  }

  updateMealPlanRate(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/meal-plan-rates/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteMealPlanRate(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/meal-plan-rates/' + id + '/').pipe(
      map(this.extractData));
  }

  // Rate Configuration Methods
  getRateConfigurations(data?: any): Observable<any> {
    let url = endpoint + 'pricing/rate-configurations/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createRateConfiguration(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/rate-configurations/', data).pipe(
      map(this.extractData));
  }

  updateRateConfiguration(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/rate-configurations/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteRateConfiguration(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/rate-configurations/' + id + '/').pipe(
      map(this.extractData));
  }

  // Bed Configuration Rates Methods
  getBedConfigurationRates(data?: any): Observable<any> {
    let url = endpoint + 'pricing/bed-configuration-rates/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createBedConfigurationRate(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/bed-configuration-rates/', data).pipe(
      map(this.extractData));
  }

  updateBedConfigurationRate(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/bed-configuration-rates/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteBedConfigurationRate(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/bed-configuration-rates/' + id + '/').pipe(
      map(this.extractData));
  }

  // Rate Categories Methods
  getRateCategories(data?: any): Observable<any> {
    let url = endpoint + 'pricing/rate-categories/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createRateCategory(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/rate-categories/', data).pipe(
      map(this.extractData));
  }

  updateRateCategory(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/rate-categories/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteRateCategory(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/rate-categories/' + id + '/').pipe(
      map(this.extractData));
  }

  // Rate Types Methods
  getRateTypes(data?: any): Observable<any> {
    let url = endpoint + 'pricing/rate-types/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createRateType(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/rate-types/', data).pipe(
      map(this.extractData));
  }

  updateRateType(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/rate-types/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteRateType(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/rate-types/' + id + '/').pipe(
      map(this.extractData));
  }

  // Currencies Methods
  getCurrencies(data?: any): Observable<any> {
    let url = endpoint + 'pricing/currencies/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  createCurrency(data: any): Observable<any> {
    return this.http.post(endpoint + 'pricing/currencies/', data).pipe(
      map(this.extractData));
  }

  updateCurrency(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'pricing/currencies/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteCurrency(id: string): Observable<any> {
    return this.http.delete(endpoint + 'pricing/currencies/' + id + '/').pipe(
      map(this.extractData));
  }

  // Quotes Methods
  getQuotes(data?: any): Observable<any> {
    let url = endpoint + 'quotes/quotes/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getQuote(id: string): Observable<any> {
    return this.http.get(endpoint + 'quotes/quotes/' + id + '/').pipe(
      map(this.extractData));
  }

  getQuoteWithHotels(id: string): Observable<any> {
    return this.http.get(endpoint + 'quotes/quotes/' + id + '/with_hotels/').pipe(
      map(this.extractData));
  }

  getQuoteCompareOptions(id: string): Observable<any> {
    return this.http.get(endpoint + 'quotes/quotes/' + id + '/compare_options/').pipe(
      map(this.extractData));
  }

  createQuote(data: any): Observable<any> {
    return this.http.post(endpoint + 'quotes/quotes/', data).pipe(
      map(this.extractData));
  }

  // Transport Suppliers
  getTransportSuppliers(): Observable<any> {
    return this.http.get(endpoint + 'pricing/transport-suppliers/').pipe(
      map(this.extractData));
  }

  // Vehicle Types
  getVehicleTypes(): Observable<any> {
    return this.http.get(endpoint + 'pricing/vehicle-types/').pipe(
      map(this.extractData));
  }

  // Bed Configurations
  getBedConfigurations(): Observable<any> {
    return this.http.get(endpoint + 'accommodations/bed-configurations/').pipe(
      map(this.extractData));
  }

  updateQuote(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'quotes/quotes/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteQuote(id: string): Observable<any> {
    return this.http.delete(endpoint + 'quotes/quotes/' + id + '/').pipe(
      map(this.extractData));
  }

  selectAccommodation(id: string, data: any): Observable<any> {
    return this.http.post(endpoint + 'quotes/quotes/' + id + '/select_accommodation/', data).pipe(
      map(this.extractData));
  }

  approveQuote(id: string, data?: any): Observable<any> {
    return this.http.post(endpoint + 'quotes/quotes/' + id + '/approve/', data || {}).pipe(
      map(this.extractData));
  }

  finalizeQuote(id: string): Observable<any> {
    return this.http.post(endpoint + 'quotes/quotes/' + id + '/finalize/', {}).pipe(
      map(this.extractData));
  }

  getQuoteWorkflowStatus(id: string): Observable<any> {
    return this.http.get(endpoint + 'quotes/quotes/' + id + '/workflow_status/').pipe(
      map(this.extractData));
  }

  // Vouchers Methods
  getVouchers(data?: any): Observable<any> {
    let url = endpoint + 'vouchers/service-vouchers/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getVoucher(id: string): Observable<any> {
    return this.http.get(endpoint + 'vouchers/service-vouchers/' + id + '/').pipe(
      map(this.extractData));
  }

  createVoucher(data: any): Observable<any> {
    return this.http.post(endpoint + 'vouchers/service-vouchers/', data).pipe(
      map(this.extractData));
  }

  updateVoucher(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'vouchers/service-vouchers/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteVoucher(id: string): Observable<any> {
    return this.http.delete(endpoint + 'vouchers/service-vouchers/' + id + '/').pipe(
      map(this.extractData));
  }

  // Voucher Accommodations Methods
  getVoucherAccommodations(data?: any): Observable<any> {
    let url = endpoint + 'vouchers/voucher-accommodations/';
    if (data) {
      const params = new URLSearchParams();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          params.append(key, data[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getVoucherAccommodation(id: string): Observable<any> {
    return this.http.get(endpoint + 'vouchers/voucher-accommodations/' + id + '/').pipe(
      map(this.extractData));
  }

  createVoucherAccommodation(data: any): Observable<any> {
    return this.http.post(endpoint + 'vouchers/voucher-accommodations/', data).pipe(
      map(this.extractData));
  }

  updateVoucherAccommodation(id: string, data: any): Observable<any> {
    return this.http.put(endpoint + 'vouchers/voucher-accommodations/' + id + '/', data).pipe(
      map(this.extractData));
  }

  deleteVoucherAccommodation(id: string): Observable<any> {
    return this.http.delete(endpoint + 'vouchers/voucher-accommodations/' + id + '/').pipe(
      map(this.extractData));
  }

  // Dashboard and Reports Methods
  getDashboardSummary(filters?: any): Observable<any> {
    let url = endpoint + 'reports/dashboard/summary/';
    if (filters) {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined) {
          params.append(key, filters[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getDashboardWidgets(): Observable<any> {
    return this.http.get(endpoint + 'reports/dashboard/widgets/').pipe(
      map(this.extractData));
  }

  getDashboardQuickStats(filters?: any): Observable<any> {
    let url = endpoint + 'reports/dashboard/quick_stats/';
    if (filters) {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined) {
          params.append(key, filters[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  // Report Generation Methods
  generateReport(reportId: string, filters?: any): Observable<any> {
    const data = { filters: filters || {} };
    return this.http.post(endpoint + 'reports/report-configurations/' + reportId + '/generate_report/', data).pipe(
      map(this.extractData));
  }

  exportReport(reportId: string, format: string, filters?: any): Observable<any> {
    const data = { 
      format: format,
      filters: filters || {} 
    };
    return this.http.post(endpoint + 'reports/report-configurations/' + reportId + '/export_report/', data).pipe(
      map(this.extractData));
  }

  getReportFilters(): Observable<any> {
    return this.http.get(endpoint + 'reports/filters/').pipe(
      map(this.extractData));
  }

  // Financial Report Methods
  getFinancialReport(filters?: any): Observable<any> {
    let url = endpoint + 'reports/financial/';
    if (filters) {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined) {
          params.append(key, filters[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getIncomeReport(filters?: any): Observable<any> {
    let url = endpoint + 'reports/income/';
    if (filters) {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined) {
          params.append(key, filters[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getRevenueReport(filters?: any): Observable<any> {
    let url = endpoint + 'reports/revenue/';
    if (filters) {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined) {
          params.append(key, filters[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getBookingReport(filters?: any): Observable<any> {
    let url = endpoint + 'reports/bookings/';
    if (filters) {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined) {
          params.append(key, filters[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getCustomerReport(filters?: any): Observable<any> {
    let url = endpoint + 'reports/customers/';
    if (filters) {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined) {
          params.append(key, filters[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }

  getPerformanceReport(filters?: any): Observable<any> {
    let url = endpoint + 'reports/performance/';
    if (filters) {
      const params = new URLSearchParams();
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined) {
          params.append(key, filters[key]);
        }
      });
      url += '?' + params.toString();
    }
    return this.http.get(url).pipe(map(this.extractData));
  }
  
  private notify$ = new BehaviorSubject<Record<string, any>>({});

  getOptions() {
    return this.options;
  }

  setOptions(options: AppSettings) {
    this.options = Object.assign(defaults, options);
    this.notify$.next(this.options);
  }

  private options = defaults;

  getLanguage() {
    return this.options.language;
  }

  setLanguage(lang: string) {
    this.options.language = lang;
    this.notify$.next({ lang });
  }
}
